module.exports = __webpack_public_path__ + "img/festa5.1a416921.png";